import * as React from "react"

import konstantin from "src/images/reviews/konstantin-bulenkov.png"
import yuri from "src/images/reviews/yuri-vasyutinskiy.png"
import tres from "src/images/reviews/tres-finocchiaro.png"
import chuck from "src/images/reviews/chuck-woods.png"

export const reviews = [
    {
        id: 2,
        title: "Konstantin Bulenkov",
        details: "Head of JetBrains Runtime",
        description: "We rely on the Liberica team's experience and expertise to provide timely updates for our customers; together, we keep JetBrains Runtime secure and performant.",
        image: konstantin
    },
    {
        id: 1,
        title: "Yury Vasyutinskiy",
        details: "Team Lead at FlowTraders",
        description: "Stability, speed and accuracy are all very important factors for us. Liberica, our main JDK distribution, was onboarded without any hiccups. We are happy with the level of support provided by the BellSoft team.",
        image: yuri
    },
    {
        id: 3,
        title: "Chuck Woods",
        details: "Engineering and Operations Manager at SoftChalk",
        description: "We were impressed with the support BellSoft offers and we could not find another distribution that would integrate so painlessly with our product line as Liberica JDK.",
        image: chuck
    },
    {
        id: 4,
        title: "Tres Finocchiaro",
        details: "QZ Tray desktop software",
        description: "I wish I had discovered BellSoft 6 years ago. The level of follow-through and professionalism is a trait we share with BellSoft and is the key to a successful product.",
        image: tres
    },
];
